import React, { useEffect, useState } from "react";
import { Button, Card, CardBody, Col, Container, Row } from "reactstrap";
import BreadCrumb from "../../../../Components/Common/BreadCrumb";
/// import UserCreate from "./UserCreate";
// import UserEdit from "./UserEdit";
// import DeleteComponent from "../../../Components/Common/deleteComponent/DeleteComponent";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { getLedgersByCustomerID } from "../../../../helpers/urlConfig/apiFunctions";
import LedgersCreate from "./LedgersCreate";
import { useParams } from "react-router-dom";
import DeleteComponent from "../../../../Components/Common/deleteComponent/DeleteComponent";
import LedgerDetailsEdit from "./LedgerDetailsEdit";
import { documentTitle } from "../../../../helpers/documentTitle";
import errorResponseHandler from "../../../../helpers/errorResponseHandler";

const LedgersDetails = () => {
  const [modal_list, setmodal_list] = useState(false);
  const [debit, setDebit] = useState(null);
  const [credit, setCredit] = useState(null);

  const [ledgerDetails, setLedgerDetails] = useState([]);
  const { customerID } = useParams();

  documentTitle("Ledgers");

  /** Edit & Delete Options  - Start */
  const [modal_delete, setmodal_delete] = useState(false);
  const [edit_modal_list, set_edit_modal_list] = useState(false);
  const [currentLedgerDetails, setCurrentLedgerDetails] = useState(null);
  const [deleteId, setDeleteLedgerDetailsId] = useState(null);
  const [deleteName, setDeleteLedgerDetailsName] = useState(null);

  const tog_list = () => setmodal_list(!modal_list);
  const edit_tog_list = () => set_edit_modal_list(!edit_modal_list);
  const tog_delete = () => setmodal_delete(!modal_delete);

  /** Edit & Delete Options  - End */

  const fetchData = async () => {
    try {
      const body = {
        customer_id: customerID,
      };
      const response = await getLedgersByCustomerID(body);

      if (response.statusCode === 200) {
        setDebit(response.totalDebits);
        setCredit(response.totalCredits);
        setLedgerDetails(response.data);
      } else {
        errorResponseHandler(response);
      }
    } catch (error) {
      console.error(error.message);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(ledgerDetails);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Ledger Details");
    XLSX.writeFile(workbook, "Ledger Details.xlsx");
  };

  const exportToPDF = () => {
    const doc = new jsPDF();
    doc.text("Ledger Details List", 14, 10);

    // Generate the table
    doc.autoTable({
      head: [
        [
          "SL.No",
          "Customer Name",
          "Description",
          "Debit",
          "Credit",
          "Created At",
        ],
      ],
      body: ledgerDetails.map((ledger, index) => [
        index + 1,
        ledger.customer_name,
        ledger.description,
        ledger.debit,
        ledger.credit,
        ledger.created_at,
      ]),
      startY: 20, // Start the table after the title
    });

    // Get the final Y-position after the table
    const finalY = doc.lastAutoTable.finalY + 10; // Add some spacing after the table
    doc.setFontSize(9);
    // Add the total debit, credit, and balance values
    doc.text(`Total Debit: ${debit}`, 145, finalY);
    doc.text(`Total Credit: ${credit}`, 145, finalY + 5);
    doc.text(`Total Balance: ${debit - credit}`, 145, finalY + 10);

    // Save the PDF
    doc.save("Ledger Details.pdf");
  };

  const handleEditClick = (ledgerDetails) => {
    setCurrentLedgerDetails(ledgerDetails);
    set_edit_modal_list(true);
  };

  const onClickRemoveBtn = (ledgerDetails) => {
    setDeleteLedgerDetailsId(ledgerDetails.id);
    setDeleteLedgerDetailsName("ID");
    tog_delete();
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb
            title="Ledgers Details"
            pageTitle="Ledgers Details"
            exportToExcel={exportToExcel}
            exportToPDF={exportToPDF}
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <div id="customerList">
                    <Row className="g-4 mb-3">
                      <Col className="col-sm-auto">
                        {/* <div>
                          <Button
                            color="primary"
                            onClick={exportToExcel}
                            className="me-1"
                          >
                            Excel
                          </Button>
                          <Button color="secondary" onClick={exportToPDF}>
                            PDF
                          </Button>
                        </div> */}
                      </Col>
                      <Col className="col-sm">
                        <div className="d-flex justify-content-sm-end">
                          <div className="search-box ms-2">
                            <input
                              type="text"
                              className="form-control search"
                              placeholder="Search..."
                            />
                            <i className="ri-search-line search-icon"></i>
                          </div>
                        </div>
                      </Col>
                    </Row>

                    <div className="table-responsive table-card mt-3 mb-1">
                      <table className="table align-middle table-nowrap">
                        <thead className="table-light">
                          <tr>
                            <th>SL.No</th>
                            <th>Customer Name</th>
                            <th>Description</th>
                            <th>Debit</th>
                            <th>Credit</th>
                            <th>Created At</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {ledgerDetails.map((ledgerDetail, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{ledgerDetail.customer_name}</td>
                              <td>{ledgerDetail.description}</td>
                              <td>{ledgerDetail.debit}</td>
                              <td>{ledgerDetail.credit}</td>
                              <td>{ledgerDetail.created_at}</td>
                              <td>
                                <div className="d-flex gap-2">
                                  <div className="edit">
                                    <button
                                      className="btn btn-sm btn-success"
                                      onClick={() =>
                                        handleEditClick(ledgerDetail)
                                      }
                                    >
                                      Edit
                                    </button>
                                  </div>
                                  {/* <div className="remove">
                                    <button
                                      className="btn btn-sm btn-danger"
                                      onClick={() =>
                                        onClickRemoveBtn(ledgerDetail)
                                      }
                                    >
                                      Remove
                                    </button>
                                  </div> */}
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      {ledgerDetails.length === 0 && (
                        <div className="text-center mt-4">
                          <p>No Ledgers found.</p>
                        </div>
                      )}
                    </div>
                    {/* Totals Section */}
                    <Col className="mt-4">
                      <Col md={2} className="text-start">
                        <p>
                          <strong>Total Debits:</strong> {debit || 0}
                        </p>
                      </Col>
                      <Col md={4} className="text-start">
                        <p>
                          <strong>Total Credits:</strong> {credit || 0}
                        </p>
                      </Col>
                      <Col md={4} className="text-start">
                        <p>
                          <strong>Total Balance:</strong> {debit - credit || 0}{" "}
                          (Debit - Credit)
                        </p>
                      </Col>
                    </Col>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      <LedgersCreate
        modal_list={modal_list}
        setmodal_list={setmodal_list}
        tog_list={tog_list}
        fetchData={fetchData}
      />

      {edit_modal_list && (
        <LedgerDetailsEdit
          modal_list={edit_modal_list}
          setmodal_list={set_edit_modal_list}
          tog_list={edit_tog_list}
          fetchData={fetchData}
          currentLedgerDetails={currentLedgerDetails}
        />
      )}

      <DeleteComponent
        modal_delete={modal_delete}
        tog_delete={tog_delete}
        fetchData={fetchData}
        deleteId={deleteId}
        keyName="Customer Ledger"
        deleteName={deleteName}
      />
    </React.Fragment>
  );
};

export default LedgersDetails;
